import { HttpClient } from '@angular/common/http';
import { inject, Injectable, signal } from '@angular/core';
import { BehaviorSubject, catchError, map, Observable, tap, throwError } from 'rxjs';
import { ENDPOINTS } from '../constants';
import { LoginModel } from '../models';


@Injectable({
  providedIn: 'root'
})
export class LoginService {
  private userDetails = new BehaviorSubject<any>(null);
  currentUser = this.userDetails.asObservable();
  #http = inject(HttpClient);
  #tokenSignal = signal<string | null>(localStorage.getItem('token'));
  #refreshTokenSignal = signal<string | null>(localStorage.getItem('refreshToken'));
  #expiresAtSignal = signal<number | null>(
    localStorage.getItem('expiresAt') ? parseInt(localStorage.getItem('expiresAt')!, 10) : null
  );
  loginApi(authData: LoginModel) {
    return this.#http.post<any>(ENDPOINTS.AUTH.LOGIN, authData).pipe(
      map(response => {
        if (response?.status === 200) return response;
        throw 'Login failed'
      }),
      tap({
        next: response => {
          const { token, refreshToken } = response?.result ?? {};
          this.setSession({ token, refreshToken });
          this.userDetails.next('new message');
          this.userDetails.next(response.result);
        }
      }),
      catchError(error => {
        console.error('Login failed', error);
        return throwError(() => error);
      })
    );
  }

  AgencyInfo(): Observable<any> {
    return this.#http.get(ENDPOINTS.AUTH.AGENCY_DETAILS).pipe(
      map((response: any) => response)
    );
  }
  private setSession({ token, refreshToken }: { token: string; refreshToken: string }) {
    const expiresAt = new Date().getTime() + 3600 * 1000;

    this.#tokenSignal.set(token ?? null);
    this.#refreshTokenSignal.set(refreshToken ?? null);
    this.#expiresAtSignal.set(expiresAt);

    localStorage.setItem('token', token ?? '');
    localStorage.setItem('refreshToken', refreshToken ?? '');
    localStorage.setItem('expiresAt', expiresAt.toString());
  }
  getToken() {
    return localStorage.getItem('token');
  }
  logout(redirect = true): void {
    this.#tokenSignal.set(null);
    this.#refreshTokenSignal.set(null);
    this.#expiresAtSignal.set(null);
    localStorage.removeItem('token');
    localStorage.removeItem('refreshToken');
    localStorage.removeItem('expiresAt');
    localStorage.removeItem('agency_name');

  }
}
